import { faMinusSquare, faPlusSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, IconButton } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import React from "react";


export default function ItemCard(props) {
  return (
    <Card
      style={{
        maxWidth: 300,
        margin: 10,
        height: "fit-content"
      }}
    >
      <CardActionArea>
        <CardMedia
          component="img"
          style={{
            height: 210
          }}
          image={props.image}
        />
        <CardContent>
          <Typography gutterBottom variant="button">
            {props.name}
          </Typography>
        </CardContent>
      </CardActionArea>

      <CardActions
        style={{ justifyContent: "space-between", margin: "0px 10px" }}
      >
        <Typography
          variant="h6"
          color="textSecondary"
          component="h6"
          style={{ pointerEvents: "none" }}
        >
          ${props.price}
        </Typography>
        <div>
          {" "}
          Quantity
          <IconButton
            aria-label="delete"
            size="small"
            onClick={() => props.removeItem(props.productId)}
          >
            <FontAwesomeIcon
              icon={faMinusSquare}
              style={{ fontSize: "20px", color: "#00bc84" }}
            />
          </IconButton>
          <span>{props.quantity}</span>
          <IconButton
            aria-label="add"
            size="small"
            onClick={() => props.purchaseItem(props.productId)}
          >
            <FontAwesomeIcon
              icon={faPlusSquare}
              style={{ fontSize: "20px", color: "#00bc84" }}
            />
          </IconButton>
        </div>

        {/* <Button
          variant="contained"
          size="small"
          color="primary"
          //href={props.link}
          disabled={props.isItemAdded}
          onClick={() => props.purchaseItem(props.productId)}
        >
          {props.btnLabel}
        </Button> */}
      </CardActions>

      <ExpansionPanel
        expanded={props.expanded.includes(props.productId)}
        onChange={() => props.handleExpandClick(props.productId)}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography>Product Details</Typography>
        </ExpansionPanelSummary>

        <ExpansionPanelDetails>
          <Typography>{props.description}</Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </Card>
  );
}



// WEBPACK FOOTER //
// ./src/components/Common/ItemCard.js